import _ from "lodash"
/**
 * 有向图环检测
 * https://www.cnblogs.com/mdumpling/p/9494878.html 深度遍历方式
 *
 * @param digraph eg. { a: ["b", "c"], b: ["c"], c: ["a"] }
 * @returns {boolean}
 */
export function circleDetect(digraph) {
  let state = {} // 每个节点的状态 undefined代表节点没有访问过，-1代表节点被访问过一次，但它还有孩子节点未被访问完，1代表该节点的深度遍历已经结束
  for (let node in digraph) {
    if (circleDetectRecursion(digraph, state, node)) return true
  }
  return false
}

function circleDetectRecursion(digraph, state, curNode) {
  if (state[curNode] === -1) return true
  if (state[curNode] === 1) return false
  let nexts = digraph[curNode] || []
  state[curNode] = -1
  for (let node of nexts) {
    if (circleDetectRecursion(digraph, state, node)) return true
  }
  state[curNode] = 1
  return false
}

/**
 * 广度优先遍历
 * @param arr 待遍历数组
 * @param childFuc 取得子数组的函数,返回数组
 * @param cbk 遍历函数
 * @param cloneDeep 是否深拷贝
 */
export function bfs({
  arr = [],
  childFuc = obj => obj.children,
  cbk = obj => console.log(obj),
  cloneDeep = true,
  withParent = true
} = {}) {
  const queue = cloneDeep ? _.cloneDeep(arr) : [].concat(arr)
  queue.forEach(item => (item._deep = 0))
  while (queue.length) {
    let obj = queue.shift()
    let res = cbk(obj)
    if (res === false) break
    queue.push(
      ...(childFuc(obj) || []).map(child => {
        child._deep = obj._deep + 1
        withParent && (child._parent = obj)
        return child
      })
    )
  }
}

export function getTreeDeep(treeData) {
  let arr = []
  arr.push(treeData)
  let depth = 0
  while (arr.length > 0) {
    let temp = []
    for (let i = 0; i < arr.length; i++) {
      temp.push(arr[i])
    }
    arr = []
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].children && temp[i].children.length > 0) {
        for (let j = 0; j < temp[i].children.length; j++) {
          arr.push(temp[i].children[j])
        }
      }
    }
    if (arr.length >= 0) {
      depth++
    }
  }
  return depth - 1
}
